// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planoscontas_UpdateValorInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /planoscontas/template/item/{id}/valor
 *
 * Updates the predicted value for a fixed budget account item.
 */
import { registerContract } from './validate'

export interface Planoscontas_UpdateValorInput {
valor: number
}

registerContract('Planoscontas_UpdateValorInput', {
  valor: { type: 'number',  required: true },
})
